export default __webpack_public_path__ + "static/media/icon-voice-outbound-white.34f173b3.svg";